





































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import LaporanSvc from "@/services/LaporanRekapOrderBankDarah";
import {
  OpsiNilai,
  OrderBankDarahRow,
  RekapOrderSummary,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class LaporanRekapOrderBankDarahPage extends Vue {
  filter: {
    tgl_start: string;
    tgl_end: string;
    unit_id: string | null;
    jenis: string[];
    status: string[];
    term: string | null;
  } = {
    tgl_start: moment().startOf("month").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    unit_id: null,
    jenis: [],
    status: [],
    term: null
  };

  rows: (OrderBankDarahRow & { key: string })[] = [];
  summary: RekapOrderSummary | null = null;
  jenisItems: OpsiNilai[] = [];
  statusItems: OpsiNilai[] = [];
  maksBaris = 0;
  loading = false;
  downloading = false;

  readonly headers = [
    { text: "No Order / Tgl", value: "nomor", width: "170px" },
    { text: "Jenis", value: "jenis_label" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Unit / Pemohon", value: "unit", sortable: false },
    { text: "Status", value: "status", width: "140px" },
    { text: "Sampel", value: "sampel", sortable: false, width: "90px" },
    { text: "Diterima", value: "diterima_at", width: "130px" },
    { text: "Selesai", value: "selesai_at", width: "130px" },
    { text: "Tunggu Terima", value: "waktu_tunggu_terima_menit", width: "110px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res = await LaporanSvc.list(this.filter);
      this.rows = (res.rows || []).map(r => ({ ...r, key: `${r.sumber}:${r.id}` }));
      this.summary = res.summary;
      this.jenisItems = res.jenis_options;
      this.statusItems = res.status_options;
      this.maksBaris = res.maks_baris;
    } catch {
      this.rows = [];
      this.summary = null;
    } finally {
      this.loading = false;
    }
  }

  async unduh() {
    this.downloading = true;
    try {
      await LaporanSvc.downloadExcel(this.filter);
    } catch {
      return;
    } finally {
      this.downloading = false;
    }
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  warnaTeks(status: string): string {
    return (STATUS_WARNA[status] || "blue-grey").split(" ")[0];
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  menit(val: number | null): string {
    if (val === null || val === undefined) return "-";
    if (val < 60) return `${val} mnt`;
    const jam = Math.floor(val / 60);
    return `${jam} j ${val % 60} mnt`;
  }
}
